import priorAuthorizationReferralDetailsPropType from './priorAuthorizationReferralDetailsPropType';

export { priorAuthorizationReferralDetailsPropType };
